import PropTypes from 'prop-types';
import { formatTime } from '../../utils/timeFormatter';

export function Timestamp({ createdAt }) {
  return <time>{formatTime(createdAt)}</time>;
}

Timestamp.propTypes = {
  createdAt: PropTypes.string.isRequired,
};
